export default __webpack_public_path__ + "assets/models/2dcb0390b2e905062ec960be930b3142.glb";